// Esta vista es la wrapper donde se muestra el Test de RA, corresponde al step 2 del flujo.
require('sass/blocks/personal-data-view.scss');
// @ vendors
const React = require('react');
const { bindActionCreators } = require('redux');
const { connect } = require('react-redux');
// @ components
const WelcomeCard = require('components/welcomeCard/welcomeCard').welcomeCard;
const { RASuitabilityTestView } = require('routes/RASuitabilityTestView/RASuitabilityTestView');
// @ commons
// @ actions
const checkStatusActions = require('actions/RACheckStatus');

class SuitabilityTestView extends React.Component {
    render() {
        return (
            <div className="ra-test-data-view">
                <RASuitabilityTestView />
                <WelcomeCard />
            </div>
        );
    }
}

module.exports.constructor = SuitabilityTestView;
module.exports.SuitabilityTestView = connect(
    state => ({
        immCheckStatus: state.raCheckStatus,
        immStepsState: state.steps,
        errorState: state.error,
    }),
    dispatch => ({
        checkStatusActions: bindActionCreators(checkStatusActions, dispatch),
    })
)(SuitabilityTestView);
